(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ekaani-store-switcher"]) return;
  try {
    
(function(){
 var root=document.querySelector('[data-ekaani-store-switcher]');if(!root)return;
 var key='ekaani-store-mode',path=window.location.pathname,params=new URLSearchParams(window.location.search);
 var homePage=path==='/'||path==='/index';
 var explicitHome=params.get('view')==='home';
 var explicitGifting=homePage&&!explicitHome;
 var saved=null;try{saved=sessionStorage.getItem(key)}catch(e){}
 var mode=explicitHome?'home':explicitGifting?'gifting':saved==='home'?'home':'gifting';
 function applyMenus(){
  document.documentElement.setAttribute('data-ekaani-mode',mode);
  document.dispatchEvent(new Event('ekaani:mode-change'));
  root.setAttribute('data-mode',mode);
  root.classList.toggle('ekaani-mode-home',mode==='home');root.classList.toggle('ekaani-mode-gifting',mode==='gifting');
  root.querySelectorAll('[data-store]').forEach(function(a){var active=a.getAttribute('data-store')===mode;a.classList.toggle('is-active',active);if(active)a.setAttribute('aria-current','page');else a.removeAttribute('aria-current')});
 }
 function saveMode(value){try{sessionStorage.setItem(key,value)}catch(e){}}
 saveMode(mode);applyMenus();
 root.querySelectorAll('[data-store]').forEach(function(a){a.addEventListener('click',function(){saveMode(a.getAttribute('data-store'))})});
 document.addEventListener('DOMContentLoaded',applyMenus);window.addEventListener('pageshow',applyMenus);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-reels"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
 document.querySelectorAll('.ekaani-reels').forEach(function(section){
  var lightbox=document.createElement('div');
  lightbox.className='ekaani-reels__lightbox';
  lightbox.innerHTML='<button type="button" class="ekaani-reels__lightbox-close" aria-label="Close full screen">&times;</button><video controls autoplay playsinline></video>';
  document.body.appendChild(lightbox);
  var fullVideo=lightbox.querySelector('video');
  function closeFull(){
    fullVideo.pause(); fullVideo.removeAttribute('src'); fullVideo.load();
    lightbox.classList.remove('is-open'); document.body.style.overflow='';
  }
  section.querySelectorAll('.ekaani-reels__fullscreen').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault(); e.stopPropagation();
      var source=btn.parentElement.querySelector('video source');
      var video=btn.parentElement.querySelector('video');
      var src=source?source.src:(video?video.currentSrc||video.src:'');
      if(!src)return;
      fullVideo.src=src; lightbox.classList.add('is-open'); document.body.style.overflow='hidden';
      var p=fullVideo.play(); if(p&&p.catch)p.catch(function(){});
      if(fullVideo.requestFullscreen){fullVideo.requestFullscreen().catch(function(){});}
      else if(fullVideo.webkitEnterFullscreen){try{fullVideo.webkitEnterFullscreen();}catch(err){}}
    });
  });
  lightbox.querySelector('.ekaani-reels__lightbox-close').addEventListener('click',closeFull);
  lightbox.addEventListener('click',function(e){if(e.target===lightbox)closeFull()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&lightbox.classList.contains('is-open'))closeFull()});
  var track=section.querySelector('[data-reels-track]'); if(!track)return;
  var prev=section.querySelector('.ekaani-reels__prev'),next=section.querySelector('.ekaani-reels__next');
  function step(){var card=track.querySelector('.ekaani-reels__card');return card?card.getBoundingClientRect().width+16:300}
  if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'})});
  if(next)next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'})});
  section.querySelectorAll('.ekaani-reels__play').forEach(function(btn){
   btn.addEventListener('click',function(){
    var v=btn.parentElement.querySelector('video');if(!v)return;
    section.querySelectorAll('video').forEach(function(o){if(o!==v)o.pause()});
    if(v.paused){v.play();btn.classList.add('is-playing')}else{v.pause();btn.classList.remove('is-playing')}
   });
   var v=btn.parentElement.querySelector('video');if(v)v.addEventListener('click',function(){v.pause();btn.classList.remove('is-playing')});
  });
 });
});

  } catch(e) { console.error(e); }
})();
})();
